import { useFlags } from "launchdarkly-react-client-sdk";
import { LAUNCHDARKLY_UPDATE } from "../constants/action-types";

type LdFlags = ReturnType<typeof useFlags>;

/**
 * Creates an `Action` instance to update the state segment, which contains actual LaunchDarkly flags for the current user.
 * @param flags Key-value map of flags.
 */
export const updateLdFlags = (flags: LdFlags) => {
    return {
        type: LAUNCHDARKLY_UPDATE,
        payload: flags,
    };
};
